import { Flex, theme } from '@styles';
import { number, object } from 'prop-types';
import React from 'react';

const PercentageProgressBar = ({ containerProps, percentage }) => (
  <Flex
    backgroundColor={theme.colors.white[30]}
    height={3}
    opacity={0.2}
    width="100%"
    {...containerProps}
  >
    <Flex
      backgroundColor={theme.colors.schoolBusYellow[100]}
      height={3}
      width={`${percentage}%`}
    />
    <Flex height={3} width={`${100 - percentage}%`} />
  </Flex>
);

PercentageProgressBar.propTypes = {
  containerProps: object,
  percentage: number.isRequired,
};

PercentageProgressBar.defaultProps = {
  containerProps: {},
};

export default PercentageProgressBar;
